import _ from '../../core/utils'
const sliderSectionConfig = {
    sections: _.selectAll( '.section--default-slider' ),
    autoPlay: 3000
}
export default sliderSectionConfig